import React, { Component } from "react";
import Popup from "reactjs-popup";
import AcceptShareModal from "./AcceptShareModal/AcceptShareModal";
import "./Notifications.scss";
import bookmarknot from "../../../../assets/image/icon/bookmark black.png";

export default class Notifications extends Component {
    renderBtnNotification = notification => {
        return (
            <div>
                <button className="dropdown-item notification small d-flex align-items-center">
                    <img className="notification-icon" src={bookmarknot} alt=""/>
                    <div>
                        <b>
                            {notification.bookmark_share.user.name +
                                " " +
                                notification.bookmark_share.user.last_name}
                        </b>{" "}
                        (<i>@{notification.bookmark_share.user.username}</i>)
                        wants to share some bookmarks with you.
                    </div>
                </button>
                <div className="dropdown-divider"></div>
            </div>
        );
    };

    renderNotification = notification => {
        return (
            <Popup
                key={notification.id}
                contentStyle={{ width: "fit-content(500px)" }}
                lockScroll={true}
                className="animated fadeIn faster"
                trigger={this.renderBtnNotification(notification)}
                modal
                closeOnDocumentClick
                on="click"
            >
                {close => (
                    <AcceptShareModal
                        id={notification.id}
                        removeNotification={this.props.removeNotification}
                        alert={this.props.alert}
                        userInfo={this.props.userInfo}
                        close={close}
                        notification={notification}
                        // addUserShared={this.props.addUserShared}
                    />
                )}
            </Popup>
        );
    };

    render() {
        if (this.props.isLoadingNotifications)
            return (
                <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            );
        if (
            !this.props.notifications ||
            this.props.notifications.length === 0
        ) {
            return (
                <div className="small text-center m-2">
                    <i>You don't have notifications.</i>
                </div>
            );
        }

        return (
            <>
                {this.props.notifications.map(notification => {
                    return this.renderNotification(notification);
                })}
            </>
        );
    }
}
